import { render, staticRenderFns } from "./UploadIconGrey.vue?vue&type=template&id=a90419ba&"
import script from "./UploadIconGrey.vue?vue&type=script&lang=js&"
export * from "./UploadIconGrey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports